$( document ).ready(function() {
      $('.order-panel .atc_btn').click(function(){
   setTimeout(function(){
   $.ajax({
        type: 'GET',
        url: "/cart",
        dataType: "HTML",
        success: function(matt)
        {
        
   var change =  $(matt).find('.cart-box.grid-demo').html();
            $('.mini-cart-items').html('');
            $(".mini-cart-items").append(change);
         
        },
   
  });
           }, 1000);
   });
  
  if($(window).width() > 1100){
      var copyArticl = $('.blog-main.article .artical-tag').html();
      $('.blog-main.article .artical-tag').remove();
      $('.lefttt .blog-posts-date').after('<div class="artical-tag">'+copyArticl+'</div>');
   }
  if($(window).width() < 600){ 
	var H1height = $('.lefttt h1').height(); 
	if(H1height < 195 && H1height > 155){ 
		$('.lefttt h1').css('font-size','18px'); 
		$('.lefttt h1').css('line-height','22px'); 
	}else if(H1height < 155 && H1height > 115){
		$('.lefttt h1').css('font-size','20px'); 
		$('.lefttt h1').css('line-height','24px'); 
	}else if(H1height < 115 && H1height > 75){
		$('.lefttt h1').css('font-size','22px'); 
		$('.lefttt h1').css('line-height','26px'); 
	}else if(H1height > 75){
		$('.lefttt h1').css('font-size','26px'); 
		$('.lefttt h1').css('line-height','32px'); 
	} 
	$('.lefttt h1').css('opacity','1'); 
  }
});
 
  /* CD */
  $(document).on('change','.iq-swatch input[type="radio"]', function(){
    //$(this).parents('.iq-product').find('.iq-img').addClass('loading');
    $(this).parents('.iq-product').find('.iq-img img').attr('src',$(this).prop('value'));
  });

  $(window).on('scroll',function(){
    if($(window).width() <= 1100) return;
    if($(this).scrollTop() >= $('.header-top').height()) {
      $('body').addClass('sticky-header');
    }
    else {
      $('body').removeClass('sticky-header');
    }
  });

$(document).ready(function(){
  $(".faq_details .section_container .faq_heading").click(function(){
    if($(this).hasClass('is_open') ){
      $(this).removeClass('is_open')
      $(this).parents('.faq_des_container').find('.faq_description').slideUp();
    }
    else{
      $(this).addClass('is_open') 
       $(this).parents('.faq_des_container').find('.faq_description').slideDown();
    }
  });
});
